module.exports = __webpack_public_path__ + "img/bnr_challenge_top_side_1.13671e9b.png";